export enum TaskEntityType {
  'PATIENT' = 'PATIENT',
  'DOCTOR' = 'DOCTOR',
  'FACILITY' = 'FACILITY',
  'CLIENT' = 'CLIENT',
}
